export default __webpack_public_path__ + "static/media/Icon12.f6bc4d91.svg";